export default __webpack_public_path__ + "static/media/4_carousel.1388e049.jpeg";